import {equityColumnPresets} from "./EquityGridColumns";
import {IColumnDefOf, IUiGridConstants} from "ui-grid";
import {CurrentUser} from "../../../../services/user/models/CurrentUser";
import {FeatureNames} from "../../../../types/UserConfig";
import {EquityPositionViewModel} from "../../models/EquityPositionViewModel";
import IGridOptions = uiGrid.IGridOptions;
import {translate} from "angular";

interface ColumnPreset {
    readonly name: string,
    readonly icon: string,
    readonly minWidth: number,
    resetFn: () => Array<IColumnDefOf<EquityPositionViewModel>>
}

interface WithColumnPresets {
    columnPresets: Array<ColumnPreset>
}

type GridOptions = IGridOptions & WithColumnPresets

export function equityGridOptions(translateService: translate.ITranslateService, currentUser: CurrentUser, gridUtil: any, constants: IUiGridConstants, screenSize: any): GridOptions {
    const rowTemplate = currentUser.hasFeature(FeatureNames.FEATURE_ORDER_ENTRY) ? "tf-ui-grid/ui-grid-row" : undefined;

    return {
        multiSelect: false,
        enableRowSelection: false,
        enableFullRowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        treeRowHeaderAlwaysVisible: false,
        flatEntityAccess: true,
        enableVerticalScrollbar: constants.scrollbars.ALWAYS,
        enableHorizontalScrollbar: constants.scrollbars.NEVER,
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        enableFiltering: true,
        enableGridMenu: false,
        enableColumnResizing: true,
        saveFilter: false,
        saveScroll: false,
        saveFocus: false,
        minRowsToShow: 10,
        columnPresets: [
            {
                name: "column-picker.MOBILE",
                icon: "icon-phone2",
                minWidth: 400,
                resetFn: () => mobileEquityGridColumns(translateService, constants)
            },
            {
                name: "column-picker.TABLET",
                icon: "icon-tablet",
                minWidth: 700,
                resetFn: () => tabletEquityGridColumns(translateService, constants)
            },
            {
                name: "column-picker.CONDENSED",
                icon: "icon-tablet fa-rotate-90",
                minWidth: 700,
                resetFn: () => condensedEquityGridColumns(translateService, constants)
            },
            {
                name: "column-picker.DESKTOP",
                icon: "icon-desktop",
                minWidth: 1200,
                resetFn: () => desktopEquityGridColumns(translateService, constants)
            }
        ],
        columnDefs: equityGridColumns(translateService, constants, screenSize),
        data: [],
        showColumnFooter: true,
        rowTemplate,
        onRegisterApi: (gridApi: any) => {
            gridUtil.disableAnimations(gridApi.grid.element);
        }
    };
}

function equityGridColumns(translateService: translate.ITranslateService, constants: IUiGridConstants, screenSize: any) {
    if (screenSize.is("xs")) {
        return mobileEquityGridColumns(translateService, constants);
    } else if (screenSize.is("sm")) {
        return tabletEquityGridColumns(translateService, constants);
    } else if (screenSize.is("md")) {
        return condensedEquityGridColumns(translateService, constants);
    } else {
        return desktopEquityGridColumns(translateService, constants);
    }
}

function mobileEquityGridColumns(translateService: translate.ITranslateService, constants: IUiGridConstants) {
    return equityColumnPresets(translateService, constants).mobile.columns;
}

function tabletEquityGridColumns(translateService: translate.ITranslateService, constants: IUiGridConstants) {
    return equityColumnPresets(translateService, constants).tablet.columns;
}

function condensedEquityGridColumns(translateService: translate.ITranslateService, constants: IUiGridConstants) {
    return equityColumnPresets(translateService, constants).condensed.columns;
}

function desktopEquityGridColumns(translateService: translate.ITranslateService, constants: IUiGridConstants) {
    return equityColumnPresets(translateService, constants).desktop.columns;
}
